"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../style");
var Select_1 = __importDefault(require("../data-entry/Select"));
var layout_1 = require("../layout");
var DEFAULT_PAGE_SIZES = [10, 25, 50, 100];
var SizeChanger = function (props) {
    var value = props.value, _a = props.options, options = _a === void 0 ? DEFAULT_PAGE_SIZES : _a, onChange = props.onChange;
    var selectOptions = options.map(function (v) { return ({ label: "" + v, value: "" + v }); });
    var theme = style_1.useTheme();
    var selectedItem = selectOptions.find(function (option) { return option.value === "" + value; });
    return (react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center" },
        react_1.jsx(Select_1.default, { options: selectOptions, value: selectedItem, onChange: function (option) {
                onChange(+option.value);
            } }),
        react_1.jsx("span", { css: {
                fontSize: 16,
                fontWeight: 400,
                color: theme.color.GRAY.DEFAULT,
            } }, "records/page")));
};
exports.default = SizeChanger;
